module.exports = __webpack_public_path__ + "static/media/charactor_summoner.3e8569f2.png";